import { render, staticRenderFns } from "./Credentials.vue?vue&type=template&id=128815a0&scoped=true&"
import script from "./Credentials.vue?vue&type=script&lang=js&"
export * from "./Credentials.vue?vue&type=script&lang=js&"
import style0 from "./Credentials.vue?vue&type=style&index=0&id=128815a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128815a0",
  null
  
)

export default component.exports